import { VIRTUAL_LIST_CONTAINER_CLASS_NAME } from '@modules/common/constants';
import { Box } from '@mui/material';
import { forwardRef, useContext } from 'react';
import { OuterElementContext } from './VirtualListOuterElementContext';

export const VirtualListOuterElementType = forwardRef<HTMLDivElement>(
  (props, ref) => {
    const outerProps = useContext(OuterElementContext);
    return (
      <Box
        component="div"
        ref={ref}
        {...props}
        {...outerProps}
        sx={{
          maxHeight: 'inherit !important',
        }}
        className={`${VIRTUAL_LIST_CONTAINER_CLASS_NAME} ${
          outerProps.className || ''
        }`}
      />
    );
  },
);
